import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import axios from "axios";
Vue.prototype.$axios = axios;
// import style 两个轮播插件
import 'swiper/dist/css/swiper.css';
import 'c-swipe/dist/swipe.css';
import { Swipe, SwipeItem } from 'c-swipe';
Vue.component('swipe', Swipe);
Vue.component('swipe-item', SwipeItem);
Vue.use(VueAwesomeSwiper);
// import style 两个轮播插件
// vue-amap地图
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
    key: '009614b6a91e661dd1fff4a9129e3aa5'
});
// vue-amap地图
//省市二级联动
import VDistpicker from 'v-distpicker'
Vue.component('v-distpicker', VDistpicker);
//省市二级联动

// 图片放大
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)


// 生产接口
axios.defaults.baseURL = 'https://m.yixueyijia.com/school_wap';
Vue.prototype.beseAjax = 'https://m.yixueyijia.com/school_wap/';
Vue.prototype.beseSend = 'https://open.yixueyijia.com';
// 测试
// axios.defaults.baseURL = 'https://apits.yixueyijia.com/school_wap';
// Vue.prototype.beseAjax = 'https://apits.yixueyijia.com/school_wap/';
// Vue.prototype.beseSend = 'https://open.yixueyijia.com';
Vue.config.productionTip = false;
//刷新进入页面top为0
router.beforeEach((to, from, next) => {
    // chrome
    document.body.scrollTop = 0
        // firefox
    document.documentElement.scrollTop = 0
        // safari
    window.pageYOffset = 0
    next()
});
//项目title
Vue.directive('title', {
    inserted: function(el, binding) {
        document.title = el.dataset.title
    }
})
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')